import { BACKGROUND_COLOR, BORDER_COLOR, DULL_TEXT_COLOR, DULL_TEXT_COLOR_DARKER, LIGHT_BACKGROUND_COLOR, PRIMARY_BUTTON_BACKGROUND_COLOR } from './constants';

export const styles = {
    container: {
        backgroundColor: BACKGROUND_COLOR,
        alignItems: 'center',
        justifyContent: 'center',
    },
    defaultBackgroundColor: {
        backgroundColor: BACKGROUND_COLOR,
    },
    lightBackgroundColor: {
        backgroundColor: LIGHT_BACKGROUND_COLOR,
    },
    transparentBackgroundColor: {
        backgroundColor: 'transparent',
    },
    flexGrow: {
        flexGrow: 1
    },
    flexShrink: {
        flexShrink: 1
    },
    flexRow: {
        flexDirection: 'row' as 'row',
    },
    flexRowSpaceBetween: {
        flexDirection: 'row' as 'row',
        justifyContent: 'space-between',
    },
    centerJustified: {
        justifyContent: 'center'
    },
    centerAligned: {
        alignItems: 'center'
    },
    endAligned: {
        alignItems: 'flex-end'
    },
    fullWidth: {
        width: '100%'
    },
    horizontallyCenteredContainer: {
        alignItems: 'center',
    },
    horizontallyPaddedContainer: {
        paddingHorizontal: 10,
    },
    centeredContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    inverseText: {
        color: BACKGROUND_COLOR,
    },
    justify: {
        textAlign: 'justify' as 'justify',
        textJustify: 'inter-word' as 'inter-word', 
    },
    landingPage: {
        fontSize: 50,
    },
    header1: {
        fontSize: 30,
    },
    header2: {
        fontSize: 25,
    },
    header3: {
        fontSize: 20,
    },
    header4: {
        fontSize: 15,
    },
    text: {
    },
    bold: {
        fontWeight: 'bold',
    },
    underline: {
        textDecorationLine: 'underline'
    },
    centerText: {
        textAlign: 'center' as 'center',
    },
    dullText: {
        color: DULL_TEXT_COLOR,
    },
    dullTextDark: {
        color: DULL_TEXT_COLOR_DARKER,
    },
    redText: {
        color: 'red'
    },
    moneyText: {
        color: '#7b9a6d'
    },
    borderBottom: {
        borderBottomWidth: 1,
        borderBottomColor: LIGHT_BACKGROUND_COLOR
    },
    padding: {
        padding: 10,
    },
    paddingExtra: {
        padding: 20,
    },
    paddingBottom: {
        paddingBottom: 10,
    },
    marginBottomSmall: {
        marginBottom: 5,
    },
    marginBottom: {
        marginBottom: 10,
    },
    marginBottomExtra: {
        marginBottom: 20,
    },
    marginRight: {
        marginRight: 10,
    },
    marginRightExtra: {
        marginRight: 20,
    },
    roundedCorners: {
        borderRadius: 8,
    },
    topCorners: {
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
    },
    bottomCorners: {
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8,
    },
    baseButton: {
        height: 40,
        justifyContent: 'center' as 'center',
        paddingHorizontal: 10,
    },
    disabledButton: {
        backgroundColor: DULL_TEXT_COLOR,
    },
    enabledButton: {
        backgroundColor: PRIMARY_BUTTON_BACKGROUND_COLOR,
    },
    baseTextInput: {
        height: 40,
        paddingHorizontal: 10,
        outlineColor: DULL_TEXT_COLOR,
    },
    textInput: {
        backgroundColor: BACKGROUND_COLOR,
        borderColor: BORDER_COLOR,
        borderWidth: 1,
    },
    emptyTextInput: {
        borderColor: BORDER_COLOR,
        borderWidth: 1,
        color: DULL_TEXT_COLOR,
    },
    underShadow: {
        shadowColor: '#000',
        shadowOffset: {
            width: 1,
            height: 1,
        },
        shadowOpacity: 0.1,
        shadowRadius: 8.00,
        elevation: 3,
    },
    shadow: {
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)'
    }
};
